<div class="modal-header">
    <h4>Operation Logbook</h4>

    <button type="button"
            class="btn-close"
            (click)="close()">
    </button>
</div>
<div *ngIf="operationId"
     class="operation-logbook modal-body">

    <div class="comment-list">

        <div *ngFor="let comment of comments"
             class="comment-card">

            <div class="comment-header">
                <b>{{ comment.authorName }}</b>

                <span>
                    {{ comment.createdAt | date:'dd/MM/yyyy HH:mm' }}
                </span>
            </div>

            <div class="comment-text">

                <ng-container *ngIf="editingCommentId !== comment.id; else editTemplate">

                    {{ comment.comment }}

                </ng-container>

                <ng-template #editTemplate>

                    <textarea class="form-control"
                              rows="3"
                              [(ngModel)]="editedText">
                    </textarea>

                    <div class="comment-actions mt-2">

                        <button class="btn btn-secondary btn-sm me-2"
                                (click)="cancelEdit()">
                            Cancel
                        </button>

                        <button class="btn btn-primary btn-sm"
                                (click)="saveEdit(comment)">
                            Save
                        </button>

                    </div>

                </ng-template>

            </div>

            <div class="comment-actions">
                <small *ngIf="comment.lastChangedAt">
                    Edited:
                    {{ comment.lastChangedAt | date:'dd/MM/yyyy HH:mm' }}
                </small>

                <button *ngIf="comment.canEdit"
                        class="btn btn-sm btn-outline-primary"
                        (click)="startEdit(comment)">
                    Edit
                </button>
            </div>
        </div>

    </div>

    <div class="comment-entry">

        <textarea class="form-control"
                  placeholder="Write a comment..."
                  rows="3"
                  [(ngModel)]="newComment">
        </textarea>

        <button class="btn btn-primary mt-2"
                (click)="postComment()">

            Add Note

        </button>
    </div>
</div>
